import { z } from "zod";
import { fromZodError } from "zod-validation-error";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const readableZodValidationError = (errorMessage: any) => {
  const validationError = fromZodError(errorMessage);

  return {
    errorMessage: Object.values(validationError)[0][0].message,
    errorPath: Object.values(validationError)[0][0].path[0],
  };
};

export const wasteCurrentSubcategory = z.object({
  name: z.string().refine((val) => val.length > 0, {
    message: "Select a category to continue",
  }),
  parentCategory: z.string().refine((val) => val.length > 0, {
    message: "Select a category to continue",
  }),
});

export const wasteLocation = z.object({
  locationOfWaste: 
  z.object({
    address_line_1: z.string(),
    address_line_2: z.string(),
    town_city: z.string(),
    county: z.string(),
    postcode: z.string(),
    country: z.string(),
    UPRN: z.string(), 
    USRN: z.string(),
    latitude: z.string(),
    longitude: z.string(),
  }).refine((val) => val.UPRN.length > 0 && val.latitude.length > 0 && val.longitude.length > 0, {
    message: "Select a valid location to continue",
  }),
});

export const confirmationEmail = z.object({
  receiveConfirmationEmail: z.string().refine((val) => val.length > 0, {
    message: "Select an option to continue",
  }),
});

export const validateDynamicFields = (fieldName: string, response: string) => {
  return z.object({
    [fieldName]: z.string().refine(
      () => {
        return response.length > 0;
      },
      {
        message: "Select an option to continue",
      },
    ),
  });
};
